export const isAfter = (start: number, end?: number) => {
  return end ? start > end : false;
};
